<template>
  <div class="page-admin-block">
    <b-container> 
      <page-editor :alias="'apply'"></page-editor>
    </b-container>
  </div>
</template>
<script>
import PageEditor from "@/components/components/PageEditor";

export default {
  components: {
    'page-editor': PageEditor
  },  
};
</script>
<style lang="scss">
</style>